<template>
  <v-card
    class="c-heading-card-description"
    :class="{ 'c-heading-card-description--mobile': $voicer.isMobile }"
    :elevation="isListen ? 0 : 5"
  >
    <div class="c-heading-card-description__container pa-3">
      <div>
        <div class="c-heading-card-description__flex">
          <div class="mt-2">
            <div
              v-if="isListen"
              class="c-heading-card-description__labels mb-2"
            >
              <c-content-labels :content="content" />
            </div>
            <h2
              class="font-weight-bold text-alternate"
              :class="{
                'display-1': $voicer.isMobile,
                'display-1':
                  hasLongTitle === false && $voicer.isDesktopOrTablet,
                headline: hasLongTitle === true && $voicer.isDesktopOrTablet,
                listenTitle: isListen,
              }"
            >
              {{ tinyTitle }}
            </h2>
            <div
              v-if="!isListen"
              class="c-heading-card-description__labels mt-3"
            >
              <c-content-labels :content="content" />
            </div>
          </div>
        </div>
        <div
          class="c-heading-card-description__summary text-alternate mt-2"
          :class="{
            'body-2': $voicer.isMobile,
            subheading: $voicer.isDesktopOrTablet,
            'font-weight-medium': $voicer.isDesktopOrTablet && !isListen,
            listenSummary: isListen,
          }"
        >
          {{ summary }}
        </div>
      </div>
    </div>
    <v-sheet
      v-if="!isListen"
      color="primary"
      class="c-heading-card-description__actions mt-3"
    >
      <c-button-play
        :use-content="content"
        flat
        variant="texticon"
        color="white"
        show-duration
      />
    </v-sheet>
  </v-card>
</template>

<script>
import mixinContentAttributes from '../../mixins/contentAttributes'

export default {
  mixins: [mixinContentAttributes()],
  computed: {
    isListen() {
      return this.$route.path.includes('listen') || false
    },
  },
}
</script>

<style lang="scss">
.listenSummary {
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
}
.listenTitle {
  font-size: 20px !important;
  font-weight: 500 !important;
  line-height: 20px !important;
}
.c-heading-card-description {
  $c: &;

  display: flex;
  flex-direction: column;
  //max-height: 270px;
  border-radius: 4px;

  &__container {
    flex-grow: 1;
  }

  &__flex {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }

  &--mobile {
    h2 {
      display: flex;
      align-items: center;
    }

    #{$c}__summary {
      height: 72px;
    }

    #{$c}__actions {
      display: flex;
      justify-content: center;
    }
  }

  &__labels {
    display: flex;
    & > * {
      margin-right: 5px;
    }
    & > *:last-child {
      margin-right: 0px;
    }
    & > *:first-child {
      margin-left: -8px;
    }
  }

  &__actions {
    display: flex;
    justify-content: center;
  }
}
</style>
